__webpack_require__.p = "/pwa-column-extract/";